module.exports = __webpack_public_path__ + "media/images/ui__infoBoxSmall-64acd3727c76e635ea94b3a8b6c60a1c.png";